import { useCallback } from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMapEvents } from 'react-leaflet';
import styles from './LimpopoMap.module.css';
import { TILE_URL, TILE_ATTRIBUTION, TILE_MAX_ZOOM } from '../../config/mapTiles';

const LIMPOPO_CENTER = [-23.9, 29.4];

function BoundsWatcher({ onBoundsChange }) {
  const handleMove = useCallback((map) => {
    const b = map.getBounds();
    onBoundsChange({
      swLat: b.getSouth().toFixed(4),
      swLng: b.getWest().toFixed(4),
      neLat: b.getNorth().toFixed(4),
      neLng: b.getEast().toFixed(4),
    });
  }, [onBoundsChange]);

  const map = useMapEvents({
    moveend: () => handleMove(map),
    zoomend: () => handleMove(map),
  });

  return null;
}

function LimpopoMap({ markers = [], onBoundsChange }) {
  return (
    <div className={styles.wrapper}>
      <MapContainer
        center={LIMPOPO_CENTER}
        zoom={7}
        className={styles.map}
        zoomControl={true}
        scrollWheelZoom={false}
        attributionControl={false}
      >
        <TileLayer
          url={TILE_URL}
          attribution={TILE_ATTRIBUTION}
          maxZoom={TILE_MAX_ZOOM}
        />
        {onBoundsChange && <BoundsWatcher onBoundsChange={onBoundsChange} />}
        {markers.map((m) => (
          <CircleMarker
            key={m.imei}
            center={[m.lat, m.lng]}
            radius={4}
            pathOptions={{
              color: '#3FB760',
              fillColor: '#3FB760',
              fillOpacity: 0.85,
              weight: 1,
            }}
          >
            <Tooltip direction="top" offset={[0, -6]} opacity={0.95}>
              <span style={{ fontSize: 11, color: '#fff' }}>{m.imei}</span>
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}

export default LimpopoMap;
